import { pick } from 'lodash'
import { fetchFormValues } from '../../utils/formUtils/forms'
import { ENDPOINT_FILTERS, LOCATION_VALUE_ENDPOINTS } from './formValuesConfig'
import { LocationValuesData } from './types/response'

export const fetchLocationValues = (fields?: string[], formFilters?: Record<string, string | string[]>) => {
    const endpoints = fields ? pick(LOCATION_VALUE_ENDPOINTS, fields) : LOCATION_VALUE_ENDPOINTS

    return fetchFormValues<LocationValuesData>(endpoints, formFilters, ENDPOINT_FILTERS)
}
